import { AppointmentModel } from '@devexpress/dx-react-scheduler';
import formatMinutes from 'helpers/formatMinutes';
import { wholeDayInSeconds } from 'helpers/timeConsts';

interface GetWorkScheduleHoursProps {
  workSchedules: AppointmentModel[];
  day: number;
}

export default function getWorkScheduleHours({
  workSchedules,
  day,
}: GetWorkScheduleHoursProps) {
  const workSchedulesForDay = workSchedules.filter(
    (workSchedule) => workSchedule.day === day,
  );

  if (!workSchedulesForDay.length) {
    return null;
  }

  const earliestWorkSchedule = workSchedulesForDay.reduce(
    (acc, currentWorkSchedule) => {
      if (!acc) {
        return currentWorkSchedule;
      }

      return new Date(acc.startDate) < new Date(currentWorkSchedule.startDate)
        ? acc
        : currentWorkSchedule;
    },
    workSchedulesForDay[0],
  );

  const latestWorkSchedule = workSchedulesForDay.reduce(
    (acc, currentWorkSchedule) => {
      if (!acc || !acc.endDate) {
        return currentWorkSchedule;
      }

      return new Date(acc.endDate) >
        new Date(currentWorkSchedule.endDate as string)
        ? acc
        : currentWorkSchedule;
    },
    {
      ...workSchedulesForDay[0],
      endDate: workSchedulesForDay[0].endDate
        ? workSchedulesForDay[0].endDate
        : workSchedulesForDay[0].startDate,
    },
  );

  const isLatestWorkScheduleEndDateEqualsMidnight =
    latestWorkSchedule.timeTo === wholeDayInSeconds;

  return {
    timeFrom: {
      hours: new Date(earliestWorkSchedule.startDate).getHours(),
      minutes: formatMinutes(
        new Date(earliestWorkSchedule.startDate).getMinutes(),
      ),
    },
    timeTo: {
      hours: isLatestWorkScheduleEndDateEqualsMidnight
        ? 24
        : new Date(latestWorkSchedule.endDate as string).getHours(),
      minutes: isLatestWorkScheduleEndDateEqualsMidnight
        ? '00'
        : formatMinutes(
            new Date(latestWorkSchedule.endDate as string).getMinutes(),
          ),
    },
  };
}
